/* eslint-disable no-undef */

const logEvent = ({ action, payload }) => {
  // console.log('logging event', action);
  gtag('event', action, payload);
};

export { logEvent };
